export default __webpack_public_path__ + "static/media/mailSent.76007c40.svg";